import { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

import { StyledTableCell, StyledTableHeadCell, TableCellInner } from '../../index.styles'
import { UpdateTableHeaderRowContainer } from '../index.styles'
import { UpdatesTableConfigProps, UpdatesTableHeadProps } from './types'

export const UpdatesTableColumnHeaders = (props: UpdatesTableHeadProps) => {
  const { t } = useTranslation()
  const { tableColumns } = props

  const profileField = tableColumns.find(column => column.fieldName === 'profile')
  const updatesField = tableColumns.find(column => column.fieldName === 'updates')
  const updatedAtField = tableColumns.find(column => column.fieldName === 'updatedAt')
  const unreadField = tableColumns.find(column => column.fieldName === 'unread')

  const tableHeaderColumnsComponents: Record<UpdatesTableConfigProps['fieldName'], () => ReactNode> = {
    // eslint-disable-next-line react/no-unstable-nested-components
    profile: () => <StyledTableHeadCell>{profileField ? t(profileField.columnTitle) : ''}</StyledTableHeadCell>,
    // eslint-disable-next-line react/no-unstable-nested-components
    updates: () => <StyledTableHeadCell>{updatesField ? t(updatesField.columnTitle) : ''}</StyledTableHeadCell>,
    // eslint-disable-next-line react/no-unstable-nested-components
    updatedAt: () => <StyledTableHeadCell>{updatedAtField ? t(updatedAtField.columnTitle) : ''}</StyledTableHeadCell>,
    // eslint-disable-next-line react/no-unstable-nested-components
    unread: () => <StyledTableHeadCell>{unreadField ? t(unreadField.columnTitle) : ''}</StyledTableHeadCell>,
  }

  return (
    <UpdateTableHeaderRowContainer>
      {tableColumns.map((tableColumn: UpdatesTableConfigProps) => {
        const { columnTitle, restCellProps = {}, fieldName } = tableColumn
        const cellComponent = tableHeaderColumnsComponents[fieldName]

        return (
          <StyledTableCell
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...restCellProps}
            $header
            key={`column-head-${String(fieldName)}`}
            data-testid={`head-${String(fieldName)}_testid`}
          >
            <TableCellInner>
              {cellComponent ? (
                cellComponent()
              ) : (
                <Typography variant="h3">{columnTitle && <Trans>{columnTitle}</Trans>}</Typography>
              )}
            </TableCellInner>
          </StyledTableCell>
        )
      })}
    </UpdateTableHeaderRowContainer>
  )
}
